import React, { Props, useEffect, useState } from "react"

import { Button, Card, CardContent, Checkbox, Divider, FormControlLabel, Typography } from "@material-ui/core"
import classes from "./index.module.css"
import parcelsRepository from 'client-sdk/src/Repository/parcels-repository';
import handleNotfication from "../../utils/handleNotfication";
import handleError from "../../utils/handleError";

const inboundItems = [
  {
    name: 'shrink',
    label: 'شیرینک',
    info: 'در این سرویس تمامی کالا های موجود در محموله با استفاده از پلاستیک حرارت دیده روکش می‌شوند.',
    code: 'SHIRINK'
  },
  {
    name: 'labelAttachment',
    label: 'برچسب گذاری',
    info: 'لیبل و یا برچسب اختصاصی که میتواند شامل قیمت، لوگو و یا دیگر اطلاعات مورد نیاز شما باشد بر روی کالاها نصب میشود.',
    code: 'LABEL_ATTACHMENT'
  },
  {
    name: 'safety',
    label: 'ایمن سازی',
    info: 'در صورتی که کالای ارسال شده نیاز به اعمال تغییرات به صورت سطحی در ساختار دارند می‌توانید از این سرویس استفاده نمایید.',
    code: 'SAFETY'
  },
  {
    name: 'repackage',
    label: 'تغییر بسته‌بندی',
    info: 'در این سرویس کالاهای محموله میتواند در هنگام ورود بسته‌بندی شوند و یا تغیراتی در بسته‌بندی کالاها اعمال شود.',
    code: 'RE_PACKAGE'
  },
  {
    name: 'kitting',
    label: 'ترکیب چند قطعه',
    info: 'کیتینگ به معنی ساخت یک پکیج فروش با استفاده از چندین کالا است که میتواند به صورت مجزا ارسال شده و تحت عنوان یک کالا جای‌گذاری شود.',
    code: 'KITTING'
  }
]

const QCItems = [
  {
    name: 'productIdentification',
    label: 'هویت سنجی',
    info: 'با انتخاب این گزینه تمامی کالاهای موجود در محموله به صورت تک به تک مورد بررسی قرارمیگیرند',
    code: 'PRODUCT_IDENTIFICATION'
  },
  {
    name: 'checkDate',
    label: 'بررسی تاریخ تولید و انقضا',
    code: 'CHECK_DATE'
  },
  {
    name: 'test',
    label: 'بررسی عملکرد کالا',
    code: 'TEST'
  },
  {
    name: 'checkContents',
    label: 'بررسی محتویات کارتن',
    code: 'CHECK_CONTENTS'
  },
  {
    name: 'requestedQc',
    label: 'کنترل کیفی درخواستی',
    info: 'شما می‌توانید با انتخاب این گزینه کنترل کیفی مورد نظر خود را شخصی سازی نمایید',
    code: 'REQUESTED_QC'
  }
]

const initialItems = {
    id: 0,
    parcelId: 0,
    shrink: false,
    labelAttachment: false,
    modifyPackage: false,
    repackage: false,
    kitting: false,
    checkItems: false,
    checkDate: false,
    test: false,
    checkContents: false,
    requestedQc: false,
    inboundDescription: "",
    qcDescription: ""
  }

export function CustomizedItems(props: Props) {
    const [editMode, setEditMode] = useState(false)
    const [customizedItems,setCustomizedItems] = useState([])
    const {editable, getParcelWithId, id, parcel} = props

    useEffect(() => {
        console.log(parcel?.parcelCustomizedOperationDTO )
        setCustomizedItems(parcel?.parcelCustomizedOperationDTO || initialItems)
    }, [parcel])

    const handleCustomizedItemChange = event => {
        const newItems = { ...customizedItems }
        newItems[event.target.name] = event.target.checked
        setCustomizedItems(newItems)
    };

    const editModeToggle = () => {
        if (editMode) {
          updateCustomizedItems()
        } else {
          setEditMode(true)
        }
    }

    const updateCustomizedItems = async () => {
        try {
          await parcelsRepository.updateCustomizedOperation({ payload: { body: { ...customizedItems }, id  } })
          getParcelWithId(id)
          setEditMode(false)
          handleNotfication("محموله با موفقیت تغییر کرد", "success")
        } catch (error: any) {
          handleError(error)
        }
      }

    return (
        <Card style={{ paddingTop: '0', marginBottom: "24px" }}>
        <CardContent>
          <div className={classes.itemContainer}>
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>اینباند</span>
            <div className={classes.itemList}>
              {inboundItems.map(item => (
                <>
                  {editMode ?
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleCustomizedItemChange}
                          checked={customizedItems[item.name]}
                          name={item.name}
                          color="primary"
                          size='small'
                        />
                      }
                      label={
                        <div style={{ display: "flex", alignItems: "center", columnGap: "10px" }}>
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: '400',
                              color: 'rgba(47, 72, 88, 1)',
                            }}
                          >
                            {item.label}
                          </Typography>
                        </div>
                      }
                    />
                    :
                    <span style={{ color: customizedItems[item.name] ? "#313131" : "#D3D7E8", lineHeight: "38px" }}>{item.label}</span>
                  }
                </>
              ))}
            </div>
            {customizedItems?.inboundDescription && <>
              <Divider style={{ width: '100%' }} />
              <p style={{ marginBottom: "0" }}>{customizedItems?.inboundDescription}</p>
            </>}
          </div>
          <div className={classes.itemContainer} style={{ marginTop: "24px" }}>
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>کنترل کیفی</span>
            <div className={classes.itemList}>
              {QCItems.map(item => (
                <>
                  {editMode ?
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleCustomizedItemChange}
                          checked={customizedItems[item.name]}
                          name={item.name}
                          color="primary"
                          size='small'
                        />
                      }
                      label={
                        <div style={{ display: "flex", alignItems: "center", columnGap: "10px" }}>
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: '400',
                              color: 'rgba(47, 72, 88, 1)',
                            }}
                          >
                            {item.label}
                          </Typography>
                        </div>
                      }
                    />
                    :
                    <span style={{ color: customizedItems[item.name] ? "#313131" : "#D3D7E8", lineHeight: "38px" }}>{item.label}</span>
                  }
                </>
              ))}
            </div>
            {customizedItems?.qcDescription && <>
              <Divider style={{ width: '100%' }} />
              <p style={{ marginBottom: "0" }}>{customizedItems?.qcDescription}</p>
            </>}
          </div>
          {editable && <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: '24px', padding: '6px 16px' }}
              onClick={editModeToggle}
            >
              {editMode
                ? 'تایید'
                : 'ویرایش'}
            </Button>
          </div>}
        </CardContent>
      </Card>
    )
}